<template>
  <div class="swap-order-detail">
    <div class="main-title bbn">
      <p>{{ $t('lang.User Info') }}</p>
    </div>
    <div class="main-body">
      <table class="table-custom">
        <thead>
        <tr>
          <th width="20%">{{ $t('lang.Card number') }}</th>
          <th width="20%">{{ $t('lang.name') }}</th>
          <th>{{ $t('lang.User contact') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ data.accountNo }}</td>
          <td>{{ data.name }}</td>
          <td>{{ data.phoneNo }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="main-title bbn" style="top:130px">
      <p>{{ $t('lang.Commodity information') }}</p>
    </div>
    <div class="main-body" style="top:175px">
      <table class="table-custom">
        <thead>
        <tr>
          <th>{{ $t('lang.Service type') }}</th>
          <th>{{ $t('lang.Device address') }}</th>
          <th>{{ $t('lang.Switch cabinet number') }}</th>
          <th>{{ $t('lang.Name of') }}<br>{{ $t('lang.switch cabinet') }}</th>
          <th>{{ $t('lang.Swap in and swap') }}<br>{{ $t('lang.out Battery SN') }}</th>
          <th>{{ $t('lang.Switch in and switch') }}<br>{{ $t('lang.out of the cabinet door') }}</th>
          <th>{{ $t('lang.Swap in and') }}<br>{{ $t('lang.out of power') }}</th>
          <th>{{ $t('lang.In electricity') }}</th>
          <th>{{ $t('lang.preferential') }}</th>
          <th>{{ $t('lang.Total amount') }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ $t('lang.Power Changing Service') }}</td>
          <td>{{ data.address }}</td>
          <td>{{ data.deviceNo }}</td>
          <td>{{ data.deviceName }}</td>
          <td>
            {{ $t('lang.Swap in') }}：{{ data.inBatteryCommunicationBoardNo }}<br/>{{ $t('lang.Swap out') }}：{{ data.outBatteryCommunicationBoardNo }}
          </td>
          <td>
            {{ $t('lang.Swap in') }}：{{ data.inChargePortSeqNo }}<br/>{{ $t('lang.Swap out') }}：{{ data.outChargePortSeqNo }}
          </td>
          <td>{{ $t('lang.Swap in') }}：{{ data.inBatterySoc }}<br/>{{ $t('lang.Swap out') }}：{{ data.outBatterySoc }}
          </td>
          <td>฿{{ data.originalAmount }}</td>
          <td>-฿{{ data.discount0Amount }}</td>
          <td>฿{{ data.dealAmount }}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="main-title bbn" style="top:310px">
      <p>{{ $t('lang.Order information') }}</p>
    </div>
    <div class="main-body" style="top:355px">
      <table class="table-custom mb20">
        <thead>
        <tr>
          <th>{{ $t('lang.Order status') }}</th>
          <th>{{ $t('lang.Order number') }}</th>
          <th>{{ $t('lang.Order time') }}</th>
          <th>{{ $t('lang.Time of payment') }}</th>
          <th v-if="data.finishTime">{{ data.statusCode == '4' ? $t('lang.closed') : $t('lang.finished') }}
            {{ $t('lang.time') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ $t('lang.' + $changeObj(order_Status_Code)[data.statusCode]) }}</td>
          <td>{{ data.orderNo }}</td>
          <td>{{ $changeTime.showTime(data.orderTime) }}</td>
          <td v-if="data.payTime">{{ $changeTime.showTime(data.payTime) }}</td>
          <td v-if="data.finishTime">{{ $changeTime.showTime(data.finishTime) }}</td>
        </tr>
        </tbody>
      </table>
      <el-button type="primary" @click="cancelBtn">{{ $t('lang.back') }}</el-button>

    </div>

  </div>
</template>
<script>
import {thailandOrderManageDetail} from '@/api/orderManagement'

import {order_Status_Code} from '@/utils/constant'

export default {
  name: 'batterySwapOrderMgmtDetailView',
  props: ['editData'],
  data() {
    return {
      order_Status_Code,
      orderNo: '',
      data: {},
    }
  },
  watch: {
    editData: {
      handler(val) {
        this.orderNo = this.editData.orderNo;
        this.queryOrderDetail();
      },
      deep: true,
    },
  },
  mounted() {
    console.log(this.editData, 'editData222');
    this.orderNo = this.editData.orderNo;
    this.thailandOrderManageDetail();
    // this.queryOrderDetail();
  },
  methods: {
    cancelBtn() {
      this.$emit('cancel');
    },
    async thailandOrderManageDetail() {
      const params = {
        orderNo: this.orderNo
      }
      try {
        const res = await thailandOrderManageDetail(params);
        console.log(res, '换电闲情res');
        this.data = res.mdata.serviceOrderDetail;
      } catch (e) {
        console.log(e);
      }
    },

    // queryOrderDetail(){
    //     let self = this;
    //     let params = {
    //         orderNo:this.orderNo
    //     };
    //     this.$http.post('/managementPlatform/electricity/orderManageDetail',this.$qs.stringify(params)).then(function(response){
    //         let res = response.data;
    //         if(!res || !res.result){
    //             self.$message({
    //                 type:"error",
    //                 message:res.message || self.$t('lang.Query failed'),
    //                 center: true
    //             });
    //             return;
    //         }
    //         console.log(res,'换电详情res');
    //         self.data = res.mdata.serviceOrderDetail;
    //     }).catch(function(response){
    //         console.log(response);
    //     });
    // }
  },
}
</script>
<style lang="scss" scoped>
.main-body {
  min-height: 50px;
}

.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  width: 100%;

  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.bbn {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/orderMgmt/batterySwapOrderMgmtDetailView.vue